import React from 'react'
import { default as Button } from '../../components/Buttons/BaseButton'
import * as S from './Dashboard.styles'

const DashboardHeroWithoutPension = ({ dashboardHeroProps }) => {
  const { needsSetup, goToPreferences, calculationFootnote, config } =
    dashboardHeroProps

  return (
    <>
      <S.MainBlock>
        <S.HeroTitle>Tu pensión estimada</S.HeroTitle>
        {needsSetup ? (
          <>
            <S.HeroEmptyTitle>Aún no hay un monto para mostrar</S.HeroEmptyTitle>
            <S.HeroEmptyText>
              Cuando completes tu configuración, aquí verás tu pensión con
              claridad.
            </S.HeroEmptyText>
            <S.HeroEmptyActions>
              <Button type="button" onClick={goToPreferences} width="auto">
                Completar configuración
              </Button>
            </S.HeroEmptyActions>
          </>
        ) : (
          <>
            <S.HeroEmptyTitle>
              Estamos listos. Pronto verás tu primer monto.
            </S.HeroEmptyTitle>
            <S.HeroEmptyText>
              Tu configuración está guardada. En cuanto exista el cálculo,
              aparece aquí.
            </S.HeroEmptyText>
          </>
        )}
      </S.MainBlock>
      <S.HeroFootnote>
        {needsSetup
          ? 'Puedes completar esto ahora o más tarde desde Preferencias.'
          : calculationFootnote(config?.method)}
      </S.HeroFootnote>
    </>
  )
}

export default DashboardHeroWithoutPension
